import { jsx as _jsx } from "react/jsx-runtime";
import Text from "@shared/components/contents/text/Text";
import DescriptionBlock from "./DescriptionBlock";
const DescriptionBlockPreview = () => {
    return (_jsx(DescriptionBlock, { title: "Titre", text: _jsx(Text, { children: "Zone avec la description" }), backgroundColor: "#FFFFFF" }));
};
export default DescriptionBlockPreview;
